<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <main-layout classes="search-view" :class="{'iOS-app': isiOSNative}">
    <main-menu-header></main-menu-header>
    <div class="filter-container">
      <search-bar :height="$mq === 'sm' ? 50 : 80" :place-change="getPlaceData"/>
      <ul class="filter-list">
        <li :class="{'on': filter.money.isShow}" >
          <span @click="toggleFilter('money')">가격대</span>
          <money-filter :is-show="filter.money.isShow"/>
        </li>
        <li :class="{'on': filter.room.isShow}" >
          <span @click="toggleFilter('room')">룸타입</span>
          <room-type-filter :is-show="filter.room.isShow" />
        </li>
        <li :class="{'on': filter.gender.isShow}" >
          <span @click="toggleFilter('gender')">성별</span>
          <gender-filter :is-show="filter.gender.isShow" />
        </li>
        <li :class="{'on': filter.optional.isShow}">
          <span @click="toggleFilter('optional')">추가필터</span>
          <optional-filter :is-show="filter.optional.isShow" />
        </li>
        <li>
          <refresh-btn :callback="hideAllFilter"/>
        </li>
      </ul>
    </div>
    <div class="flex search-result-view">
      <search-map
        :kosiwon-list="kosiwonList" @click.native="hideAllFilter"
      />
      <kosiwon-search-list-view />
    </div>
  </main-layout>
</template>

<script>
  import MainLayout from '../components/Layout/MainLayout'
  import MainMenuHeader from '../components/Header/MainMenuHeader'
  import SearchBar from '../components/Search/SearchBar'
  import MoneyFilter from '../components/Filters/MoneyFilter'
  import SearchMap from '../components/Maps/SearchMap'
  import RoomTypeFilter from '../components/Filters/RoomTypeFilter'
  import GenderFilter from '../components/Filters/GenderFilter'
  import OptionalFilter from '../components/Filters/OptionalFilter'
  import RefreshBtn from '../components/Filters/RefreshBtn'
  import KosiwonSearchListView from '../components/Kosiwons/KosiwonSearchListView'
  import { mapState } from 'vuex'
  import kosiwonApi from '../api/kosiwons'
  import CollagesAndSubwayOverlay from '../components/Maps/CollagesAndSubwayOverlay'
  import MapConstant from '../const/maps'
  import Utils from '../utils/Utils'

  export default {
    name: 'Search',
    components: {
      KosiwonSearchListView,
      RefreshBtn,
      OptionalFilter,
      GenderFilter,
      RoomTypeFilter,
      MoneyFilter,
      SearchBar,
      MainLayout,
      MainMenuHeader,
      SearchMap
    },
    data () {
      return {
        filter: {
          money: {
            isShow: false
          },
          room: {
            isShow: false
          },
          gender: {
            isShow: false
          },
          optional: {
            isShow: false
          }
        },
        kosiwonList: []
      }
    },
    computed: mapState({
      // 지도 사이즈 변경 시 (화면 사이즈 변경) 변경된다
      distance: state => state.MAPS.BOUND_DISTANCE,
      // 지도 이동 시 변경
      center: state => state.MAPS.CENTER,
      // 필터 선택 시 변경
      filters: state => state.FILTERS,
      isiOS () {
        return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
      },
      isiOSNative () {
        return this.$store.state.APP.IS_NATIVE && this.isiOS
      }
    }),
    watch: {
      // distance () {
      //   console.log(this.distance)
      //   this.fetchKosiownList()
      // },
      center () {
        if (!CollagesAndSubwayOverlay.getIsOpened()) {
          this.fetchKosiownList()
        }
      },
      filters: {
        handler() {
          this.fetchKosiownList()
        },
        deep: true
      }
    },
    methods: {
      toggleFilter (targetFilterName) {

        for (let filterName in this.filter) {
          if (this.filter.hasOwnProperty(filterName) && filterName !== targetFilterName) {
            this.filter[filterName].isShow = false
          }
        }

        this.filter[targetFilterName].isShow = !this.filter[targetFilterName].isShow
      },
      async fetchKosiownList () {
        this.$store.dispatch('setNetworkIndicator', true)
        const center = this.$store.getters.getMapCenter
        const currentOptionsFilter = {}

        for ( let i in this.filters.OPTIONAL_FILTER) {
          if (this.filters.OPTIONAL_FILTER[i]) {
            currentOptionsFilter[i] = 1
          }
        }
        // 초기 진입 시 자동으로 기본 값 세팅
        if (!center.latitude && !center.longitude) {
          await this.$store.dispatch('setMapCenter', {
            latitude: this.$route.query.latitude || MapConstant.DEFAULT_LOCATION.LATITUDE,
            longitude: this.$route.query.longitude || MapConstant.DEFAULT_LOCATION.LONGITUDE
          })
          return
        }
        const bounds = this.$store.getters.getBounds
        let kosiwonList

        if (bounds.SW && bounds.NE) {
          kosiwonList = await kosiwonApi.boundsFetch({
            sw: bounds.SW,
            ne: bounds.NE,
            moneyRange: this.filters.MONEY_RANGE,
            useSexType: this.filters.USE_SEX_TYPE,
            roomType: this.filters.ROOM_TYPE,
            optionsFilter: currentOptionsFilter
          })

          // this.$store.dispatch('setMapBounds', {
          //   sw: undefined,
          //   ne: undefined
          // })
        } else {
          this.$store.dispatch('setNetworkIndicator', false)
          // const kosiwonList = await this.axios.get(`  /kosiwons/listByRange?lat=${center.latitude}&lng=${center.longitude}&range=${this.distance}&money_range=${this.moneyRange}`)
          // kosiwonList = await kosiwonApi.fetch({
          //   lat: center.latitude,
          //   lng: center.longitude,
          //   range: this.distance,
          //   moneyRange: this.filters.MONEY_RANGE,
          //   useSexType: this.filters.USE_SEX_TYPE,
          //   roomType: this.filters.ROOM_TYPE,
          //   optionsFilter: currentOptionsFilter
          // })
        }

        // this.kosiwonList = kosiwonList.data.result;
        this.kosiwonList = kosiwonList ? kosiwonList.data.result : []

        this.$store.dispatch('setSearchKosiwonList', this.kosiwonList)
        this.$store.dispatch('setNetworkIndicator', false)
      },
      getPlaceData (place) {
        const latlng = {
          latitude: place.latitude,
          longitude: place.longitude
        }
        this.$store.dispatch('setMapCenter', latlng)
      },
      hideAllFilter() {
        for (let i in this.filter) {
          this.filter[i].isShow = false
        }
      }
    },
    mounted () {
      // 페이지 진입 시 filter 초기화.
      this.$store.dispatch('resetFilter')
      this.fetchKosiownList()
    },
    destroyed() {
      this.$store.dispatch('setMapBounds', {
        sw: undefined,
        ne: undefined
      })
      this.$store.dispatch('setSearchKosiwonList', [])
    }
  }
</script>

<style scoped lang="less">
  @import "../assets/css/palette";

  .search-view {
    .filter-container {
      display: flex;
      border-bottom: 1px solid @brown-grey;
      ul.filter-list {
        display: flex;
        flex: 3;
        background: @white;
        /*align-items: center;*/

        li {
          flex-grow: 1;
          flex-shrink: 1;
          flex-basis: 0;
          text-align: center;
          border-right: 1px solid @very-white;
          max-width: 20rem;
          position: relative;
          line-height: 8rem;
          vertical-align: middle;

          span {
            display: block;
            &:after {
              content: '';
              background: url("../assets/images/ex-open.png") no-repeat no-repeat;
              background-position: center center;
              background-size: 1.5rem 0.8rem;
              position: absolute;
              right: 1.2rem;
              top: 0.1rem;
              width:2rem;
              height:100%;
            }
          }

          &:first-child {
            border-left: 1px solid @very-white;
          }

          &:last-child {
            max-width: 8rem;
          }

          &.on {
            background-color: @windows-blue;
            color: white;

            span {
              &:after {
                background: url("../assets/images/ex-close.png") no-repeat no-repeat;
                content: ' ';
                background-position: center center;
                background-size: 1.5rem 0.8rem;
              }
            }
          }
        }
      }
    }
    .search-result-view {
      height: calc(100vh - 8rem - 8rem);
    }
    .search-bar-wrapper {
      flex: 1;
    }
  }
</style>

<style scoped lang="less" >
  @import "../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .search-view {
      overflow: hidden;
      .filter-container {
        display: block;
        .search-bar-wrapper {
          border-bottom: 2px solid @windows-blue;
        }
        ul.filter-list {
          position: relative;
          li {
            line-height: 4rem;
            flex: 2;
            position: initial;
            span {
              display: block;
              position: relative;
              &:after {
                content: '';
                background: none;
              }
            }
            &.on {
              span {
                &:after {
                  content: '';
                  background: none;
                }
              }
            }
            &:last-child {
              flex: 1;
            }
          }
        }
      }
      .search-result-view {
        display: block;
        height: calc(100vh - 15rem - 6.6rem);
      }
      &.iOS-app {
        .search-result-view {
          display: block;
          height: calc(100vh - 15rem - 0.5rem);
        }
      }
    }
  }
</style>
